import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleExtendUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle cx={28} cy={28} fill="#999" r={28} />
        <rect fill="#ccc" height={26} rx={1} width={12} x={22} y={15} />
        <g fill="#fff" fillRule="nonzero">
          <path d="M39.8 22.3a1 1 0 011.31-.09l.1.08 5 5a1 1 0 01.08 1.32l-.08.1-5 5a1 1 0 01-1.5-1.32l.08-.1L44.1 28l-4.3-4.3a1 1 0 01-.08-1.31l.08-.1zm-23.6 0a1 1 0 00-1.31-.09l-.1.08-5 5a1 1 0 00-.08 1.32l.08.1 5 5a1 1 0 001.5-1.32l-.08-.1L11.9 28l4.3-4.3a1 1 0 00.08-1.31l-.08-.1zM34 27v2H22v-2z" />
          <path d="M36 29h2v-2h-2zm-22 0h2v-2h-2zm26 0h2v-2h-2zm-22 0h2v-2h-2z" />
        </g>
      </g>
    </svg>
  );
}

SvgPicCircleExtendUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleExtendUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleExtendUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
